
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.StopCancel = {

  template() {
    return {
      items: [{
        attributes: {
          "id": 'StopCancelEvent'
        },
        items: [
          {
            attributes: {
              class: 'control-group',
              id: 'cancelReasonsContainer'
            }
          },
          {
            items: [
              {
                attributes: {
                  class: 'control-group',
                  id: 'plannedSizeContainer'
                }
              },
              {
                attributes: {
                  class: 'control-group',
                  id: 'minimumPlannedSizeContainer'
                }
              },
            ]
          }
        ]
      }]
    };
  },

  renderFields() {
    //Create Monet fields
    const cancelReasons = new Monet.UI.Fields.Render({
      name: 'cancelReasons',
      label: 'event.stopcancel.reasons',
      mandatory: false,
      type: 'LOOKUP_LIST',
      lookupEntity: 'CancelCode',
      lookupEntityColumn: 'description'
    }, 'Event').render();

    const plannedSize = new Monet.UI.Fields.Render({
      name: 'plannedSize',
      label: 'event.stopCancel.plannedSize',
      mandatory: false,
      defaultValue: '',
      type: 'PICKLIST',
      fieldDomains: [
        { description: '', value: '' },
        { description: Monet.Session.Configurations.size1Alias, value: 'plannedSize1', id: 'plannedSize1' },
        { description: Monet.Session.Configurations.size2Alias, value: 'plannedSize2', id: 'plannedSize2' },
        { description: Monet.Session.Configurations.size3Alias, value: 'plannedSize3', id: 'plannedSize3' }
      ]
    }).render();

    const minimumPlannedSize = new Monet.UI.Fields.Render({
      name: 'minimumPlannedSize',
      label: Monet.I18n.getResourcesByKey('event.stopCancel.minimumPlannedSize', ' '),
      mandatory: false,
      defaultValue: '0.00',
      type: 'DECIMAL',
    }).render();

    minimumPlannedSize.disable();

    minimumPlannedSize.updateField = () => {
      let selectedSize = plannedSize.input.selectedOptions[0].innerText;
      if (selectedSize) {
        selectedSize = `(${selectedSize})`;
        minimumPlannedSize.enable();
      } else {
        selectedSize = ' ';
        minimumPlannedSize.disable();
      }
      minimumPlannedSize.setTextLabel(Monet.I18n.getResourcesByKey('event.stopCancel.minimumPlannedSize', selectedSize));
    }

    plannedSize.removeOption(0);
    plannedSize.input.addEventListener('change', minimumPlannedSize.updateField);

    Greenmile.Checks.EventCheck.StopCancel.fields = { cancelReasons, plannedSize, minimumPlannedSize };

    //Append fields to DOM
    const cancelReasonsContainer = document.querySelector('#StopCancelEvent #cancelReasonsContainer');
    cancelReasonsContainer.appendChild(cancelReasons.rootEl);

    const plannedSizeContainer = document.querySelector('#StopCancelEvent #plannedSizeContainer');
    plannedSizeContainer.appendChild(plannedSize.rootEl);

    const minimumPlannedSizeContainer = document.querySelector('#StopCancelEvent #minimumPlannedSizeContainer');
    minimumPlannedSizeContainer.appendChild(minimumPlannedSize.rootEl);
  },

  assignParameter(jsonParam) {
    Greenmile.Checks.EventCheck.StopCancel.renderFields();
    const fields = Greenmile.Checks.EventCheck.StopCancel.fields;
    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);
      fields.cancelReasons.setValue(jsonParam.reasons);
      if (jsonParam.minimumPlanned) {
        const plannedSize = Object.keys(jsonParam.minimumPlanned)[0];
        fields.plannedSize.setValue(plannedSize);
        fields.minimumPlannedSize.setValue(jsonParam.minimumPlanned[plannedSize]);
        fields.minimumPlannedSize.updateField();
      }
    }
  },

  retrieveParameter() {
    const fields = Greenmile.Checks.EventCheck.StopCancel.fields;
    let minimumPlanned = null;
    if(fields.plannedSize.getValue()) {
      minimumPlanned = { 
        [fields.plannedSize.getValue()]: fields.minimumPlannedSize.getValue()
      };
    }
    return JSON.stringify({
      reasons: fields.cancelReasons.getFullValue().map(field => field.id),
      minimumPlanned
    });
  }

};